import { FC, useEffect, useState } from "react";
import { Box, FormControl, FormControlLabel, Grid, InputAdornment, Radio, RadioGroup } from "@mui/material";
import InputFilterFieldStyled from "@/components/styled/input.filter.field.styled";
import InputLabelStyled from "@/components/styled/input.label.styled";
import SearchIcon from "@mui/icons-material/Search";
import SwitchComponent from "@/components/styled/switch.component";
import { useTranslation } from "react-i18next";
import "./profiles.page.css";
import {
    AddProfileRequest,
    PermissionName,
    PermissionType,
    UserProfileItem,
    EditProfileRequest,
    FilterProfilesRequest,
    GetUserProfileResponse,
} from "@/models/user";
import popupService from "@/services/popupService";
import Modal from "@mui/material/Modal";
import CancelIcon from "@mui/icons-material/Cancel";
import BaseButton from "@/components/common/baseButton";
import api from "@/services/api";
import swal from "sweetalert2";
import { formatDate } from "@/util";
import filtersStore from "@/stores/filtersStore";
import TotalCountComponent from "@/components/common/resultCountComponent";

interface IdTextObject {
    id: string;
    text: string;
}
const SettingsListProfilesPage: FC = () => {
    const { t } = useTranslation();
    const [filter, setFilter] = useState<FilterProfilesRequest>({
        Keywords: "",
        PageIndex: 0,
        OrderBy: "ProfileName",
        Asc: true,
    });
    const [hasNext, setHasNext] = useState<boolean>(true);
    const [searchCounter, setSearchCounter] = useState<number>(0);
    const [isSearch, setIsSearch] = useState<boolean>(false);
    const [profiles, setProfiles] = useState<UserProfileItem[]>([]);
    const [showCreateEditProfileModal, setShowCreateEditProfileModal] = useState(false);
    const [selectedProfile, setselectedProfile] = useState<UserProfileItem>(new UserProfileItem());
    const [boPermissionsChapterList, setBoPermissionsChapterList] = useState<string[][]>([[]]);
    const [total, setTotal] = useState(0);
    const [totalFilter, setTotalFilter] = useState(0);
    const permsTitles: IdTextObject[] = [
        {
            id: "1",
            text: t("profiles.title.mainPage"),
        },
        {
            id: "2",
            text: t("profiles.title.employees"),
        },
        {
            id: "3",
            text: t("profiles.title.digitalWallet"),
        },
        {
            id: "4",
            text: t("profiles.title.orders"),
        },
        {
            id: "5",
            text: t("profiles.title.accountingDocs"),
        },
        {
            id: "6",
            text: t("profiles.title.messages"),
        },
        {
            id: "7",
            text: t("profiles.title.formsChats"),
        },
        {
            id: "8",
            text: t("profiles.title.settings"),
        },
    ];

    const handleNewProfile = () => {
        selectProfileAndShowCreateEditModal(null);
    };

    const handleEditProfile = (profile: UserProfileItem) => {
        selectProfileAndShowCreateEditModal(profile);
    };

    async function getUserProfiles(): Promise<GetUserProfileResponse> {
        const filterStore = filtersStore.profilesFilterData;
        if (filterStore != null) {
            if (filterStore.PageIndex !== 0) {
                filterStore.PageIndex = 0;
            }
            setFilter(filterStore ?? new FilterProfilesRequest());
            const responsePromise = api.getUserProfiles(filterStore ?? new FilterProfilesRequest());
            return (await responsePromise).data;
        }

        filtersStore.setProfilesFilterData(filter);
        const responsePromise = api.getUserProfiles(filter);
        return (await responsePromise).data;
    }

    const searchProfiles = async () => {
        setIsSearch(() => true);
        try {
            swal.showLoading(null);
            const result = await getUserProfiles();
            swal.close();
            setHasNext(result.hasNext);
            if (filter.PageIndex === 0) {
                setProfiles(result.rows);
                setTotal(result.total);
                setTotalFilter(result.totalFilter);
            } else {
                setProfiles((old) => [...old, ...result.rows]);
            }
            if (result.rows && result.rows.length > 0) {
                setProfiles(result.rows);
            }
            setIsSearch(() => false);
        } catch (err) {
            popupService.showApiError(err);
            return;
        } finally {
            setIsSearch(() => false);
        }
    };

    async function sortBy(sortBy: string) {
        if (filter.OrderBy !== sortBy) {
            setFilter((prevData) => ({
                ...prevData,
                Asc: true,
                OrderBy: sortBy,
                PageIndex: 0,
            }));
        } else {
            setFilter((prevData) => ({
                ...prevData,
                Asc: !filter.Asc,
                OrderBy: sortBy,
                PageIndex: 0,
            }));
        }
        setProfiles([]);
        filtersStore.setProfilesFilterData(null);
    }
    function getArrowClass(sort: string) {
        if (sort === filter.OrderBy) {
            if (filter.Asc) {
                return "top-sort-arrow";
            } else {
                return "bottom-sort-arrow";
            }
        }
        return "icon-SortArrowIcon sort-arrow-icon";
    }
    const searchProfilesClick = () => {
        setProfiles([]);
        filtersStore.setProfilesFilterData(null);
        setPageIndex(0);
        setSearchCounter((e) => e + 1);
    };

    const setPageIndex = (index?: number) => {
        setFilter({
            ...filter,
            PageIndex: index ?? filter.PageIndex + 1,
        });
    };

    function renewPermissions() {
        const ccc = Object.keys(PermissionName)
            .map((key: any) => PermissionName[key])
            .filter((value: any) => typeof value === "string") as string[];
        const abc: string[][] = [[]];
        const renderingTitles: IdTextObject[] = [];
        ccc.forEach((element) => {
            let titleNumberString = "";
            switch (element) {
                //Main page
                case "OrganizationDashboard":
                    titleNumberString = "1";
                    break;
                //Employees
                case "ListOfEmployees":
                    titleNumberString = "2";
                    break;
                case "CreateEmployee":
                    titleNumberString = "2";
                    break;
                case "EditEmployee":
                    titleNumberString = "2";
                    break;
                case "ImportEmployees":
                    titleNumberString = "2";
                    break;
                case "EmployeeGeneralInfo":
                    titleNumberString = "2";
                    break;
                case "EmployeeDigitalWallet":
                    titleNumberString = "2";
                    break;
                case "EmployeeOrders":
                    titleNumberString = "2";
                    break;
                case "EmployeeAttachedDocs":
                    titleNumberString = "2";
                    break;
                case "AddAttachedDoc":
                    titleNumberString = "2";
                    break;
                case "EditAttachedDoc":
                    titleNumberString = "2";
                    break;
                //Digital wallet
                case "ListOfWallets":
                    titleNumberString = "3";
                    break;
                case "ListOfTransactions":
                    titleNumberString = "3";
                    break;
                case "WalletBulkUpdate":
                    titleNumberString = "4";
                    break;
                case "WalletTransaction":
                    titleNumberString = "5";
                    break;
                case "WalletManagment":
                    titleNumberString = "6";
                    break;
                case "LoadingNegativeWalletAmount":
                    titleNumberString = "3";
                    break;
                //Orders
                case "ListOfOrders":
                    titleNumberString = "4";
                    break;
                //Accounting Docs
                case "ListOfDocuments":
                    titleNumberString = "5";
                    break;
                //Messages
                case "ListOfMessages":
                    titleNumberString = "6";
                    break;
                case "CreateEditMessage":
                    titleNumberString = "6";
                    break;
                //Forms and Chat
                case "ListOfForms":
                    titleNumberString = "7";
                    break;
                case "CreateForms":
                    titleNumberString = "7";
                    break;
                //Settings
                case "ManageUsers":
                    titleNumberString = "8";
                    break;
                case "ManageProfiles":
                    titleNumberString = "8";
                    break;
                case "InterfaceManagement":
                    titleNumberString = "8";
                    break;
            }
            abc.push([element, "0", titleNumberString]);
            const foundRenderingTitle = renderingTitles.find((x) => x.id === titleNumberString);
            const foundConstTitle = permsTitles.find((x) => x.id === titleNumberString);
            if (!foundRenderingTitle && foundConstTitle) {
                renderingTitles.push(foundConstTitle);
            }
        });
        abc.shift();
        setBoPermissionsChapterList(abc);
        return abc;
    }

    useEffect(() => {
        let ignore = false;
        if (!ignore) {
            searchProfiles();
        }
        return () => {
            ignore = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter.PageIndex, filter.OrderBy, filter.Asc, searchCounter]);

    function clearFilter() {
        filtersStore.setProfilesFilterData(null);
        setFilter((prevData) => ({
            ...prevData,
            Keywords: "",
        }));
        setSearchCounter(searchCounter + 1);
    }

    async function selectProfileAndShowCreateEditModal(profile: UserProfileItem | null) {
        swal.showLoading(null);
        const preReqArray = renewPermissions();
        if (profile === null) {
            setselectedProfile((prevData) => ({
                ...prevData,
                name: "",
                createdAt: "",
                id: 0,
                isActive: true,
            }));
        } else {
            setselectedProfile((prevData) => ({
                ...prevData,
                id: profile.id,
                name: profile.name,
                isActive: profile.isActive,
            }));
            try {
                const response = await api.getUserProfilePermissions(profile.id);
                const resultArray = response.data.permissions;
                preReqArray.forEach((element) => (element[1] = "0"));
                if (resultArray.length > 0) {
                    resultArray.forEach((el) => {
                        const foundPermission = preReqArray.find(
                            (x) => x[0].toString() === el.permissionName?.toString()
                        );
                        if (foundPermission && el.permissionType) {
                            foundPermission[1] = PermissionType[el.permissionType];
                        }
                    });
                    setBoPermissionsChapterList(preReqArray);
                }
            } catch (err: any) {
                popupService.showApiError(err);
                return;
            }
        }
        swal.close();
        setShowCreateEditProfileModal(true);
    }

    function fullFillDictionary(index: number, val: any) {
        const setData = boPermissionsChapterList;
        setData[index][1] = val;
        setBoPermissionsChapterList(setData);
    }

    async function createProfile() {
        const req = new AddProfileRequest();
        req.ProfileName = selectedProfile.name;
        req.isActive = selectedProfile.isActive;
        req.Permissions = [];
        const preReqArray: string[][] = JSON.parse(JSON.stringify(boPermissionsChapterList));
        if (!req.ProfileName) {
            swal.fire({
                icon: "error",
                text: t("organization.userProfiles.alert.emptyName") as string,
            });
            return;
        }
        const pa = preReqArray.filter((x) => x[1] !== "0");
        pa.forEach((el: any) => {
            req.Permissions.push({
                permissionName: el[0],
                permissionType: el[1],
            });
        });
        try {
            swal.showLoading(null);
            const response = await api.addUserProfile(req);
            if (response.data.id) {
                setShowCreateEditProfileModal(false);
                setSearchCounter(searchCounter + 1);
                swal.close();
            }
        } catch (err) {
            popupService.showApiError(err);
            return;
        }
    }

    async function editProfile() {
        if (!selectedProfile.id) {
            return;
        }
        const req = new EditProfileRequest();
        req.Id = selectedProfile.id;
        req.ProfileName = selectedProfile.name;
        req.isActive = selectedProfile.isActive;
        req.Permissions = [];
        const preReqArray: string[][] = JSON.parse(JSON.stringify(boPermissionsChapterList));
        if (!req.ProfileName) {
            swal.fire({
                icon: "error",
                text: t("organization.userProfiles.alert.emptyName") as string,
            });
            return;
        }
        const pa = preReqArray.filter((x) => x[1] !== "0");
        pa.forEach((el: any) => {
            req.Permissions.push({
                permissionName: el[0],
                permissionType: el[1],
            });
        });
        // if (!req.Permissions.length) {
        //     swal.fire({
        //         icon: "error",
        //         text: t("organization.userProfiles.alert.emptyPermissions") as string,
        //     });
        //     return;
        // }
        try {
            swal.showLoading(null);
            const response = await api.editUserProfile(req);
            swal.close();
            if (response.data.id) {
                setShowCreateEditProfileModal(false);
                setselectedProfile((prevData: UserProfileItem) => ({
                    ...prevData,
                    isActive: response.data.isActive,
                }));

                setSearchCounter((e) => e + 1);
            }
        } catch (err) {
            popupService.showApiError(err);
            return;
        }
    }

    const createEditProfileModal = showCreateEditProfileModal ? (
        <div>
            <Modal
                open={showCreateEditProfileModal}
                onClose={() => setShowCreateEditProfileModal(false)}
                sx={{ backdropFilter: "blur(6px)" }}
            >
                <div className="create-edit-modal">
                    <div className="create-edit-modal-header">
                        <div className="font-style-24 title-modal-header-title">{t("settings.profile.NewProfile")}</div>
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <CancelIcon
                                onClick={() => setShowCreateEditProfileModal(false)}
                                style={{ color: "#586A84", cursor: "pointer" }}
                            />
                        </div>
                    </div>
                    <div className="create-edit-modal-content">
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div style={{ flex: 0.85 }}>
                                <FormControl variant="standard" key="profile_name" className="profile_name">
                                    <InputFilterFieldStyled
                                        label={t("user.ProfileName")}
                                        size="small"
                                        value={selectedProfile.name}
                                        onChange={(event) => {
                                            const newValue = event.target.value;
                                            if (/^[A-Za-z\u0590-\u05FF\s]*$/.test(newValue)) {
                                                setselectedProfile((prevData) => ({
                                                    ...prevData,
                                                    name: newValue,
                                                }));
                                            }
                                        }}
                                        inputProps={{
                                            maxLength: 50,
                                        }}
                                        required
                                    ></InputFilterFieldStyled>
                                </FormControl>
                            </div>
                            <div className="profile-status-switcher">
                                <div>
                                    <span className="status_title">{t("user.Status")}</span>
                                </div>
                                <div style={{ maxWidth: "45px" }}>
                                    <SwitchComponent
                                        value={selectedProfile.isActive}
                                        checked={selectedProfile.isActive}
                                        onChange={() =>
                                            setselectedProfile((prevData: UserProfileItem) => ({
                                                ...prevData,
                                                isActive: !selectedProfile.isActive,
                                            }))
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="permissions_wrapper permissions_header">
                            <div className="names_content">{t("settings.profile.sectionTitle")}</div>
                            <div className="view_selection_content selection_content">
                                {t("settings.profile.viewTitle")}
                            </div>
                            <div className="edit_selection_content selection_content">
                                {t("settings.profile.editTitle")}
                            </div>
                            <div className="block_selection_content selection_content">
                                {t("settings.profile.blockTitle")}
                            </div>
                        </div>
                        <div className="list_of_permissions_wrapper">
                            {permsTitles.map((pt, ind) => (
                                <div key={ind}>
                                    <h3>{pt.text}</h3>
                                    <div
                                        className="permissions_wrapper list_of_permissions"
                                        key={`list_of_permissions-${ind}`}
                                    >
                                        <div className="permissions_content_wrapper">
                                            {boPermissionsChapterList.length > 0 &&
                                                boPermissionsChapterList.map((cp, mainIndex) => (
                                                    <div key={mainIndex}>
                                                        {pt.id === boPermissionsChapterList[mainIndex][2] && (
                                                            <div className="permissions_content" key={cp[0]}>
                                                                <div
                                                                    className="names_content"
                                                                    key={`names_content-${mainIndex}`}
                                                                >
                                                                    {t(`permissions.user.${cp[0]}`)}
                                                                </div>
                                                                <div
                                                                    key={`view_selection_content-${mainIndex}`}
                                                                    className="view_selection_content selection_content"
                                                                    style={{
                                                                        justifyContent: "space-between",
                                                                        flex: "0.4",
                                                                    }}
                                                                >
                                                                    <RadioGroup
                                                                        key={`rg-${mainIndex}`}
                                                                        sx={{
                                                                            flexDirection: "row",
                                                                            width: "100%",
                                                                            justifyContent: "space-between",
                                                                        }}
                                                                        defaultValue={cp[1]}
                                                                    >
                                                                        <FormControlLabel
                                                                            key={`fm1-${mainIndex}`}
                                                                            value={1}
                                                                            control={
                                                                                <Radio
                                                                                    key={`fmr1-${mainIndex}`}
                                                                                    size="small"
                                                                                    sx={{
                                                                                        "&, &.Mui-checked": {
                                                                                            color: "#405289",
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            }
                                                                            onChange={(event: any) =>
                                                                                fullFillDictionary(
                                                                                    mainIndex,
                                                                                    event.target.value
                                                                                )
                                                                            }
                                                                            label=""
                                                                            sx={{
                                                                                height: "28.5px",
                                                                                marginRight: "-11px",
                                                                            }}
                                                                            className="forms-radio-btn-text"
                                                                        />
                                                                        <FormControlLabel
                                                                            key={`fm2-${mainIndex}`}
                                                                            value={2}
                                                                            control={
                                                                                <Radio
                                                                                    key={`fmr2-${mainIndex}`}
                                                                                    size="small"
                                                                                    sx={{
                                                                                        "&, &.Mui-checked": {
                                                                                            color: "#405289",
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            }
                                                                            onChange={(event: any) =>
                                                                                fullFillDictionary(
                                                                                    mainIndex,
                                                                                    event.target.value
                                                                                )
                                                                            }
                                                                            label=""
                                                                            sx={{
                                                                                height: "28.5px",
                                                                                marginRight: "-11px",
                                                                            }}
                                                                            className="forms-radio-btn-text"
                                                                        />
                                                                        <FormControlLabel
                                                                            key={`fm3-${mainIndex}`}
                                                                            value={0}
                                                                            control={
                                                                                <Radio
                                                                                    key={`fmr3-${mainIndex}`}
                                                                                    size="small"
                                                                                    sx={{
                                                                                        "&, &.Mui-checked": {
                                                                                            color: "#405289",
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            }
                                                                            onChange={(event: any) =>
                                                                                fullFillDictionary(
                                                                                    mainIndex,
                                                                                    event.target.value
                                                                                )
                                                                            }
                                                                            label=""
                                                                            sx={{
                                                                                height: "28.5px",
                                                                                marginRight: "-11px",
                                                                            }}
                                                                            className="forms-radio-btn-text"
                                                                        />
                                                                    </RadioGroup>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div
                        className="create-edit-modal-footer"
                        style={{ display: "flex", justifyContent: "center", gap: "20%" }}
                    >
                        <BaseButton
                            style={{ padding: "0px 42px" }}
                            onClick={() => setShowCreateEditProfileModal(false)}
                            className="cancel-button"
                        >
                            {t("button.cancel")}
                        </BaseButton>
                        {selectedProfile.id ? (
                            <BaseButton
                                style={{ padding: "0px 50px" }}
                                className="basic-button green-btn"
                                onClick={() => editProfile()}
                            >
                                {t("general.btn.edit")}
                            </BaseButton>
                        ) : (
                            <BaseButton
                                style={{ padding: "0px 50px" }}
                                className="basic-button green-btn"
                                onClick={() => createProfile()}
                            >
                                {t("general.btn.create")}
                            </BaseButton>
                        )}
                    </div>
                </div>
            </Modal>
        </div>
    ) : (
        ""
    );

    return (
        <div key="profile_list_wrapper" className="profile_list_wrapper">
            <Grid className="users_management_label" sx={{ marginBottom: "5px" }}>
                <InputLabelStyled
                    shrink
                    disableAnimation
                    size="normal"
                    htmlFor="searchFilter-freetext"
                    className="free-text-label"
                    sx={{ alignSelf: "flex-end" }}
                >
                    {t("searchFilter.WhatAreYouLookingFor")}
                </InputLabelStyled>
                <BaseButton
                    onClick={() => handleNewProfile()}
                    style={{ width: "100%", maxWidth: "170px" }}
                    className="basic-button"
                >
                    {t("settings.profile.addNewProfile")}
                    <i style={{ marginInlineStart: "7px" }} className="icon-f icon-plus-icon fs-14"></i>
                </BaseButton>
            </Grid>
            <Grid
                className="user_management_filter"
                sx={{
                    display: "flex",
                    justifyContent: "start",
                }}
            ></Grid>
            <Grid
                sx={{
                    background: "#FFFFFF",
                    width: "100%",
                    margin: "0 0 20px",
                }}
            >
                <Grid
                    className="profile_management_filter"
                    sx={{
                        display: "flex",
                        justifyContent: "start",
                    }}
                >
                    <FormControl variant="standard" sx={{ width: "25%" }}>
                        <InputFilterFieldStyled
                            className="search-input"
                            onChange={(event) =>
                                setFilter((prevData) => ({
                                    ...prevData,
                                    Keywords: event.target.value,
                                }))
                            }
                            placeholder={`${t("general.SearchByNamePlaceholder")}`}
                            size="small"
                            value={filter.Keywords}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        ></InputFilterFieldStyled>
                    </FormControl>
                    <FormControl
                        sx={{
                            width: "7%",
                            display: "flex",
                            flexDirection: "column-reverse",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "100%",
                                width: "unset",
                            }}
                            className="link-element clear-all-btn"
                            onClick={() => {
                                clearFilter();
                            }}
                        >
                            {t("display.ClearAll")}
                        </Box>
                    </FormControl>
                    <FormControl sx={{ width: "7%" }}>
                        <BaseButton
                            style={{ padding: "0px 50px", width: "100%", maxWidth: "110px", justifyContent: "center" }}
                            className="basic-button"
                            onClick={() => searchProfilesClick()}
                        >
                            {t("general.filter")}
                        </BaseButton>
                    </FormControl>
                </Grid>
            </Grid>

            <TotalCountComponent
                title={t("settings.QuantityOfProfiles") as string}
                allCount={total}
                currentCount={totalFilter}
            />
            <div
                id="employee-list-grid user-management-grid"
                className="employee-list-grid user-management-grid"
                style={{ width: "65%" }}
            >
                <div className="settings-fake-thead"></div>
                <table>
                    <thead>
                        <tr>
                            <td onClick={() => sortBy("ProfileName")}>
                                {t("user.ProfileName")}
                                <i className={`icon-f ${getArrowClass("ProfileName")} fs-12`} />
                            </td>
                            <td onClick={() => sortBy("Date")}>
                                {t("settings.profile.creationDate")}
                                <i className={`icon-f ${getArrowClass("Date")} fs-12`} />
                            </td>
                            <td onClick={() => sortBy("Status")}>
                                {t("user.Status")}
                                <i className={`icon-f ${getArrowClass("Status")} fs-12`} />
                            </td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        {profiles.map((profile) => (
                            <tr key={profile.id}>
                                <td>{profile.name}</td>
                                <td>{formatDate(profile.createdAt)}</td>
                                <td>
                                    {profile.isActive ? (
                                        <div className="status-element">
                                            <div className="status-color-active"></div>
                                            <div style={{ minWidth: "80px" }}>{t("employee.ActiveStatus")}</div>
                                        </div>
                                    ) : (
                                        <div className="status-element">
                                            <div className="status-color-inactive"></div>
                                            <div style={{ minWidth: "80px" }}>{t("employee.InactiveStatus")}</div>
                                        </div>
                                    )}
                                </td>
                                <td>
                                    <div
                                        className="text-align-right"
                                        style={{ display: "flex", justifyContent: "flex-end" }}
                                    >
                                        <i
                                            onClick={() => handleEditProfile(profile)}
                                            className="icon-f icon-PencilIcon fs-20"
                                        ></i>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {createEditProfileModal}
        </div>
    );
};

export default SettingsListProfilesPage;
